import React, { useState, useEffect } from "react";
import { Col, Row, Tabs } from "antd";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import CustomConfigProvider from "../../ProfileHeader";
import ProofDocumentsPage from "./ProofDocumentsMembersList";
import ProofFamilyPage from "./ProofDocumentsFamilyList";
import ProofDocumentRequest from "./AddProofDocumentModal";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";

const ProofPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  useEffect(() => {
    dispatch(getBeneficiaryDetails());
  }, [dispatch]);

  const tabsData = [
    {
      key: "family",
      label: "أوراق الثبوتية  للأسرة",
      content: <ProofFamilyPage state={state} />,
    },
    {
      key: "member",
      label: "أوراق الثبوتية  للأفراد",
      content: <ProofDocumentsPage state={state} />,
    },
  ];

  return (
    <>
      <CustomConfigProvider
        title="أوراق الثبوتية"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        bottomMargin={1.5}
      />
      <Row justify="space-between" className="takaful--request-col-space">
        <Col
          xxl={4}
          xl={4}
          lg={4}
          md={4}
          sm={12}
          xs={12}
          style={{ marginBottom: "1.5rem" }}
        >
          <PrimaryButton
            title="إضافة أوراق الثبوتية"
            className="takaful--add-request-btn"
            onClick={() => setIsModalVisible(true)}
          />
        </Col>
      </Row>
      <Tabs
        defaultActiveKey="family"
        className="takaful--content-profile-tab takaful--registration"
        items={tabsData.map(({ key, label, content }) => ({
          key,
          label: (
            <Row style={{ width: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="tab-label">
                  <span className="tab-label-text">{label}</span>
                </div>
              </Col>
            </Row>
          ),
          children: (
            <div
              style={{
                border: "3px solid #EFEFEF",
                padding: "1.5rem",
                borderRadius: "25px",
                direction: "ltr",
              }}
            >
              {content}
            </div>
          ),
        }))}
      />
      <ModalComponent
        destroyOnClose={true}
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={700}
        modalStyle={{ top: 100 }}
      >
        <ProofDocumentRequest setIsModalVisible={setIsModalVisible} />
      </ModalComponent>
    </>
  );
};

export default ProofPage;
